module.exports = __webpack_public_path__ + "img/added-service-unit-03.50af067f.png";